module.exports = __webpack_public_path__ + "img/contact-number-icon.2b0e16e5.svg";